import { useCallback, useEffect, useRef } from 'react';

/**
 * Schedule a callback at most once per animation frame.
 */
export const useCoalescedAnimationFrame = (callback: () => void) => {
  const callbackRef = useRef(callback);
  const animationFrameRef = useRef<number | null>(null);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  const cancel = useCallback(() => {
    if (animationFrameRef.current != null) {
      cancelAnimationFrame(animationFrameRef.current);
      animationFrameRef.current = null;
    }
  }, []);

  const schedule = useCallback(() => {
    if (animationFrameRef.current != null) {
      return;
    }

    animationFrameRef.current = requestAnimationFrame(() => {
      animationFrameRef.current = null;
      callbackRef.current();
    });
  }, []);

  useEffect(() => cancel, [cancel]);

  return {
    schedule,
    cancel,
  };
};
